<template>
  <div class="header">
    <div class="centent">
      <h1>单号查询</h1>
      <div class="order-query">
        <van-field
          v-model="order"
          clearable
          class="query-input"
          autocomplete="off"
          maxlength="35"
          size="large"
          placeholder="请输入收件人手机号或者订单号查询"
        />
        <van-button
          type="primary"
          :square="true"
          class="query-button"
          :loading="loading"
          @click="handleSubmit"
          >查询</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      order: null,
      loading: false
    };
  },
  created() {
    this.order = null;
  },
  methods: {
    handleSubmit() {
      if (!this.order) {
        Toast("单号不能为空,请输入");
        return;
      }

      this.$router.push({
        path: "/orderList",
        query: {
          data: this.order
        }
      });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

::-webkit-scrollbar {
  display: none; /*隐藏滚轮*/
}

.header {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.centent {
  padding-top: 122.75px;
  height: 100%;
  box-sizing: border-box;
}

h1 {
  font-size: 24px;
  font-weight: normal;
}

.order-query {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
 
}

.query-input {
  width: 85%;
  height: 44px;
  margin: 30px 0 28px 0;
  padding: 10px 0px 10px 15px;
  font-size: 16px;
  color: #999999;
  border: 1px solid #ebebeb;
  border-radius: 5px;
   background-color: #F6F6F6;
}

.query-button {
  width: 85%;
  border-radius: 5px;
}

.van-button--primary {
  background: #f48b19;
  border-color: #f48b19;
  font-size: 17px;
}
</style>
